(function () {
  'use strict';
  if (window.__besPopupBound) return;
  window.__besPopupBound = true;

  var FORM_ID = 'bes-popup-signup';
  var KEY = 'bes_popup_v1';
  var DISMISS_DAYS = 30;
  var DELAY_MS = 8000;
  var SCROLL_TRIGGER = 0.45;

  // Cart and checkout are conversion surfaces; account pages are already
  // post-signup. Never interrupt those.
  var BLOCKED = /^\/(cart|checkout|account)/;

  function store(value) {
    try { localStorage.setItem(KEY, JSON.stringify({ v: value, t: Date.now() })); } catch (e) {}
  }

  function suppressed() {
    var raw;
    try { raw = localStorage.getItem(KEY); } catch (e) { return false; }
    if (!raw) return false;
    var parsed;
    try { parsed = JSON.parse(raw); } catch (e) { return true; }
    if (parsed.v === 'subscribed') return true;
    return (Date.now() - (parsed.t || 0)) < DISMISS_DAYS * 86400000;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // MIGRATION GUARD — keep until the SmartrMail app is UNINSTALLED, not merely
  // until its pop-up embed is switched off. The app is still installed (its
  // analytics script continues to load), so the embed can be re-enabled from
  // the theme editor in one click. Its pop-up renders
  // #sm-pop-up-<id>.sm-pop-up-container at z-index 2147483647 and fires later
  // than we do, so without this a visitor would get our sheet and then
  // SmartrMail's on top of it about twelve seconds later.
  function smartrmailPopupPresent() {
    if (document.querySelector('.sm-pop-up-container, [id^="sm-pop-up-"]')) return true;
    var scripts = document.querySelectorAll('script[src]');
    for (var i = 0; i < scripts.length; i++) {
      if (/smartrmail/i.test(scripts[i].src) && /pop_?up/i.test(scripts[i].src)) return true;
    }
    return false;
  }

  ready(function () {
    var root = document.getElementById('bes-popup');
    if (!root) return;

    var panel = root.querySelector('.bes-popup__panel');
    var posted = !!root.querySelector('[data-posted="true"]');
    var mine = window.location.hash === '#' + FORM_ID;

    // A success state rendered because a DIFFERENT customer form on the page was
    // submitted (footer signup, contact form). Showing it would be a lie, so this
    // pageview gets no pop-up at all.
    if (posted && !mine) return;

    var lastFocus = null;

    function focusables() {
      return panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])');
    }

    function open() {
      if (root.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      root.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      // Focusing the input on a phone raises the keyboard over the sheet before
      // the reader has seen the offer, so only desktop gets the field focused.
      var wide = window.matchMedia('(min-width: 601px)').matches;
      var input = root.querySelector('.bes-popup__input');
      if (wide && input) input.focus();
      else if (panel) panel.focus();
    }

    function close(reason) {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      root.hidden = true;
      document.documentElement.style.overflow = '';
      if (reason) store(reason);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (posted && mine) {
      store('subscribed');
      open();
    }

    document.addEventListener('click', function (e) {
      var el = e.target;
      if (!el) return;
      if (el.closest && el.closest('.bes-popup__close, .bes-popup__dismiss')) { close('dismissed'); return; }
      if (el === root) close('dismissed');
    });

    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close('dismissed'); return; }
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    if (posted && mine) return;

    var errored = !!root.querySelector('.bes-popup__error');
    if (errored && mine) { open(); return; }

    // Submitting counts as subscribing even before the reload lands, so a slow
    // POST can never re-arm the timer on the way out.
    var form = document.getElementById(FORM_ID);
    if (form) form.addEventListener('submit', function () { store('subscribed'); });

    if (suppressed()) return;
    if (BLOCKED.test(window.location.pathname)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (smartrmailPopupPresent()) return;

    var fired = false;
    function trigger() {
      if (fired) return;
      fired = true;
      open();
    }

    setTimeout(trigger, DELAY_MS);

    window.addEventListener('scroll', function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= SCROLL_TRIGGER) trigger();
    }, { passive: true });

    // Exit intent, pointer devices only — on touch the cursor never leaves the
    // viewport through the top edge, so this listener would be dead weight.
    if (window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (e.clientY <= 0 && !e.relatedTarget) trigger();
      });
    }
  });
})();
